export default __webpack_public_path__ + "static/media/poisson.64de90d6.jpg";